module.exports = __webpack_public_path__ + "portal-static/img/header.920d3dd3.png";